import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from './lib/utils';
// Label inherits colour from its parent container so it works on both
// the navy backdrop (text-foreground = ice-blue) and inside a light
// Card (text-card-foreground = gray-100) without contrast regressions.
// Callers can override with className="text-foreground" / "text-..." as needed.
const Label = React.forwardRef(({ className, ...props }, ref) => (_jsx(LabelPrimitive.Root, { ref: ref, className: cn('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className), ...props })));
Label.displayName = LabelPrimitive.Root.displayName;
export { Label };
//# sourceMappingURL=label.js.map